import * as Yup from 'yup';
import { DictionaryRiverBasinEuDistrict } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryRiverBasinEuDistrict>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
